import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserServices } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyGuard implements CanActivate {
  
  constructor(private _userAPI: UserServices, private router: Router) {}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    // Si no está logueado, redirige al login
    if (!this._userAPI.isLogged()) {
      this.router.navigate(['/es/login']);
      return false;
    }
    
    // Si ya está cargado el usuario, comprobamos directamente
    if (this._userAPI.sharedUser) {
      const userType = this._userAPI.sharedUser.type;
      if (userType === 'company' || userType === 'both') {
        return true;
      } else {
        // Redirige al dashboard principal si no es company o both
        this.router.navigate([next.parent.pathFromRoot[1].params['language'] + '/dashboard']);
        return false;
      }
    }
    
    // Si no está cargado el usuario pero está logueado, lo cargamos primero
    return this._userAPI.loadUser()
      .then(user => {
        const userType = this._userAPI.sharedUser.type;
        if (userType === 'company' || userType === 'both') {
          return true;
        } else {
          this.router.navigate([next.parent.pathFromRoot[1].params['language'] + '/dashboard']);
          return false;
        }
      })
      .catch(error => {
        console.error('Error loading user in CompanyGuard:', error);
        this.router.navigate(['/es/login']);
        return false;
      });
  }
}

